import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiProjectBagDropsList, apiProjectBagDropsView } from 'Services/AdminService'
import { dataDefault } from 'Views/Admin/ProjectBagDrops/MaterialTypes'

export const getData = createAsyncThunk('admin/projectBagDrops/getData', async datas => {
    const { data } = await apiProjectBagDropsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/projectBagDrops/getView', async id => {
    if (!id) return viewData
    const { data } = await apiProjectBagDropsView(id)
    data.material_types = data.material_types && data.material_types.length !== 0 ? data.material_types : [dataDefault]
    data.images = []
    data.image_remove = []
    return data
})

const viewData = {
    collection_point_id: '',
    project_id: '',
    notes: '',
    images: [],
    image_remove: [],
    material_types: [dataDefault],
}

export const projectBagDropsSlice = createSlice({
    name: 'admin/projectBagDrops',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            start: moment().startOf('month').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('month').locale('en').format('YYYY-MM-DD'),
            collection_point_id: '',
            project_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
        setCollectionPointProject: (state, { payload }) => {
            state.table.page = 1
            state.table.collection_point_id = payload.collection_point_id
            state.table.project_id = payload.project_id
        },
        setCollectionPoint: (state, { payload }) => {
            state.table.page = 1
            state.table.collection_point_id = payload
            state.table.project_id = ''
        },
        setProject: (state, { payload }) => {
            state.table.page = 1
            state.table.project_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate, setCollectionPointProject, setCollectionPoint, setProject } =
    projectBagDropsSlice.actions

export default projectBagDropsSlice.reducer
